// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';   // ⬅️ React 18
import { BrowserRouter } from 'react-router-dom';
import App from './App';

const el = document.getElementById('root');
const root = createRoot(el);

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
